import { axiosApi } from '@/axios'
import { Paginator, Params } from '@/utils/interfaces'
import { Product } from '@/utils/interfaces/topup.interface'

export const getAvailableProducts = (params?: Params) =>
  axiosApi.get<Paginator<Product>>('/topups/available-products/', { params })

export const createGenericProduct = (body: {
  client?: string
  destination_account?: string
  amount: string | number
  product: string
  count?: string
}) => axiosApi.post('/topups/create/', { count: 1, ...body })

export const createNautaTopup = (body: {
  client?: string
  destination_account?: string
  confirmation_account?: string
  amount: string | number
  product: string
  count?: string
}) => axiosApi.post('/topups/nauta/create/', { count: 1, ...body })
